import { render, staticRenderFns } from "./FeaturedBlog.vue?vue&type=template&id=22359037&"
import script from "./FeaturedBlog.vue?vue&type=script&lang=js&"
export * from "./FeaturedBlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports